import React, { useContext } from "react";
import TFUTooltip from "../../based/TFUTooltip";
import CheckBox from "../../based/inputs/CheckBox";
import TextNumber from "../../based/inputs/TextNumber";
import Textbox from "../../based/inputs/Textbox";
import TFUSelect from "../../based/inputs/TFUSelect";
import { ConfigAttributeModalContext } from "../../context/ConfigAttributeModalContext";

// Render bảng cấu hình khu vực giới hạn để khung thêu được kéo theo từng size.
const EmbroideryHoopMovementConfig = (props) => {
    const { embroideryHoopMovementConfigs, setEmbroideryHoopMovementConfigs, hoopOptions, isReadOnly } = useContext(ConfigAttributeModalContext);
    const { addRef } = props;

    // Cập nhật từng ô cấu hình khu vực di chuyển khung thêu theo size.
    const handleInputChange = (name, value, index) => {
        let data = [...embroideryHoopMovementConfigs];
        let current = data[index];
        if (name == "isStandard") data.map((item) => (item.isStandard = false));
        current[name] = value;
        setEmbroideryHoopMovementConfigs(data);
    };

    return (
        <React.Fragment>
            <div className="col-md-12 card-box p-3">
                <div className="row">
                    <div className="col-sm-12 pr-1">
                        <div className="card-box p-3">
                            <div className="form-group row">
                                <div className="col-md-3 center row">
                                    <label className="col-md-12 center">&nbsp;</label>
                                    <label htmlFor="isStandard" className="col-md-3 required">
                                        Chuẩn
                                    </label>
                                    <label htmlFor="attributeValueName" className="col-md-4 required">
                                        Tên
                                    </label>
                                    <label htmlFor="hoopId" className="col-md-5 required">
                                        Loại hoop
                                    </label>
                                </div>
                                <div className="col-md-4 center row">
                                    <label className="col-md-12 center">Mặt trước</label>
                                    <div className="col-md-4 center">
                                        <TFUTooltip content="Khoảng cách tối thiểu từ cổ áo đến vùng cho phép di chuyển khung thêu mặt trước" target="frontCollarMinMm">
                                            <label id="frontCollarMinMm" className="required" htmlFor="frontCollarMinMm">
                                                Cách cổ min
                                            </label>
                                        </TFUTooltip>
                                    </div>
                                    <div className="col-md-4 center">
                                        <TFUTooltip content="Chiều ngang khu vực mà khung thêu được phép kéo qua trái/phải ở mặt trước" target="frontMoveAreaWidthMm">
                                            <label id="frontMoveAreaWidthMm" className="required" htmlFor="frontMoveAreaWidthMm">
                                                Chiều ngang khu vực
                                            </label>
                                        </TFUTooltip>
                                    </div>
                                    <div className="col-md-4 center">
                                        <TFUTooltip content="Chiều dọc khu vực mà khung thêu được phép kéo lên/xuống ở mặt trước" target="frontMoveAreaHeightMm">
                                            <label id="frontMoveAreaHeightMm" className="required" htmlFor="frontMoveAreaHeightMm">
                                                Chiều dọc khu vực
                                            </label>
                                        </TFUTooltip>
                                    </div>
                                </div>
                                <div className="col-md-4 center row">
                                    <label className="col-md-12 center">Mặt sau</label>
                                    <div className="col-md-4 center">
                                        <TFUTooltip content="Khoảng cách tối thiểu từ cổ áo đến vùng cho phép di chuyển khung thêu mặt sau" target="backCollarMinMm">
                                            <label id="backCollarMinMm" className="required" htmlFor="backCollarMinMm">
                                                Cách cổ min
                                            </label>
                                        </TFUTooltip>
                                    </div>
                                    <div className="col-md-4 center">
                                        <TFUTooltip content="Chiều ngang khu vực mà khung thêu được phép kéo qua trái/phải ở mặt sau" target="backMoveAreaWidthMm">
                                            <label id="backMoveAreaWidthMm" className="required" htmlFor="backMoveAreaWidthMm">
                                                Chiều ngang khu vực
                                            </label>
                                        </TFUTooltip>
                                    </div>
                                    <div className="col-md-4 center">
                                        <TFUTooltip content="Chiều dọc khu vực mà khung thêu được phép kéo lên/xuống ở mặt sau" target="backMoveAreaHeightMm">
                                            <label id="backMoveAreaHeightMm" className="required" htmlFor="backMoveAreaHeightMm">
                                                Chiều dọc khu vực
                                            </label>
                                        </TFUTooltip>
                                    </div>
                                </div>
                            </div>
                            {embroideryHoopMovementConfigs.length > 0
                                ? embroideryHoopMovementConfigs.map((item, idx) => {
                                      return (
                                          <div className="form-group row" key={idx}>
                                              <div className="col-md-3 row">
                                                  <div className="col-md-3">
                                                      <CheckBox disabled={isReadOnly} checked={item.isStandard} name="isStandard" label=" " onCheckedChange={(name, value) => handleInputChange(name, value, idx)} classDiv="center" />
                                                  </div>
                                                  <div className="col-md-4">
                                                      <Textbox
                                                          id="attributeValueName"
                                                          ref={addRef}
                                                          readOnly={true}
                                                          name="attributeValueName"
                                                          className="form-control"
                                                          value={item.attributeValueName}
                                                          onChanged={(name, value) => handleInputChange(name, value, idx)}
                                                          required
                                                      />
                                                  </div>
                                                  <div className="col-md-5">
                                                      <TFUSelect
                                                          id="hoopId"
                                                          ref={addRef}
                                                          name="hoopId"
                                                          value={item.hoopId}
                                                          options={hoopOptions}
                                                          isDisabled={isReadOnly}
                                                          onChanged={(value) => handleInputChange("hoopId", value, idx)}
                                                          required
                                                      />
                                                  </div>
                                              </div>
                                              <div className="col-md-4 row">
                                                  <div className="col-md-4">
                                                      <TextNumber
                                                          id="frontCollarMinMm"
                                                          ref={addRef}
                                                          readOnly={isReadOnly}
                                                          name="frontCollarMinMm"
                                                          className="form-control required"
                                                          min={0}
                                                          required
                                                          value={item.frontCollarMinMm}
                                                          onChanged={(name, value) => handleInputChange(name, value, idx)}
                                                          decimal
                                                      />
                                                  </div>
                                                  <div className="col-md-4">
                                                      <TextNumber
                                                          id="frontMoveAreaWidthMm"
                                                          ref={addRef}
                                                          readOnly={isReadOnly}
                                                          name="frontMoveAreaWidthMm"
                                                          className="form-control required"
                                                          min={0}
                                                          required
                                                          value={item.frontMoveAreaWidthMm}
                                                          onChanged={(name, value) => handleInputChange(name, value, idx)}
                                                          decimal
                                                      />
                                                  </div>
                                                  <div className="col-md-4">
                                                      <TextNumber
                                                          id="frontMoveAreaHeightMm"
                                                          ref={addRef}
                                                          readOnly={isReadOnly}
                                                          name="frontMoveAreaHeightMm"
                                                          className="form-control required"
                                                          min={0}
                                                          required
                                                          value={item.frontMoveAreaHeightMm}
                                                          onChanged={(name, value) => handleInputChange(name, value, idx)}
                                                          decimal
                                                      />
                                                  </div>
                                              </div>
                                              <div className="col-md-4 row">
                                                  <div className="col-md-4">
                                                      <TextNumber
                                                          id="backCollarMinMm"
                                                          ref={addRef}
                                                          readOnly={isReadOnly}
                                                          name="backCollarMinMm"
                                                          className="form-control required"
                                                          min={0}
                                                          required
                                                          value={item.backCollarMinMm}
                                                          onChanged={(name, value) => handleInputChange(name, value, idx)}
                                                          decimal
                                                      />
                                                  </div>
                                                  <div className="col-md-4">
                                                      <TextNumber
                                                          id="backMoveAreaWidthMm"
                                                          ref={addRef}
                                                          readOnly={isReadOnly}
                                                          name="backMoveAreaWidthMm"
                                                          className="form-control required"
                                                          min={0}
                                                          required
                                                          value={item.backMoveAreaWidthMm}
                                                          onChanged={(name, value) => handleInputChange(name, value, idx)}
                                                          decimal
                                                      />
                                                  </div>
                                                  <div className="col-md-4">
                                                      <TextNumber
                                                          id="backMoveAreaHeightMm"
                                                          ref={addRef}
                                                          readOnly={isReadOnly}
                                                          name="backMoveAreaHeightMm"
                                                          className="form-control required"
                                                          min={0}
                                                          required
                                                          value={item.backMoveAreaHeightMm}
                                                          onChanged={(name, value) => handleInputChange(name, value, idx)}
                                                          decimal
                                                      />
                                                  </div>
                                              </div>
                                          </div>
                                      );
                                  })
                                : ""}
                        </div>
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
};

export default EmbroideryHoopMovementConfig;
